import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
import { getRoutes } from '@atlassian/jira-routes/src/ui/spa/index.tsx';
import { startJiraSpa } from './start-jira-spa.tsx';

setMark('JIRA_SPA_ENTRY_LOADED');

startJiraSpa(getRoutes);
